/**
 * Logs an error to browser's console
 *
 * @param msg The message to log
 * @param props The data to log
 * @returns void
 *
 * @example logError('The request failed', { url: 'https://example.com', foo: { bar: "baz" } })
 */
const logError = (msg, props) => {
  console.error(msg, {
    ...props,
  });
};

/**
 * Capitalizes the passed in string (e.g. "first last" becomes "First Last")
 *
 * @param val The string to be capitalized
 * @returns {string} The capitalized string
 */
const toCapitalized = (val) => {
  return val
    .toLowerCase()
    .split(' ')
    .map((word) => `${word[0].toUpperCase()}${word.slice(1, word.length)}`)
    .join(' ');
};

/**
 * Shortcut for creating a DOM element with a certain class name and setting the innerHtml
 *
 * @param tagName The name of the tag to create (e.g. 'div', 'p', etc.)
 * @param className The class name to give the element once created (e.g. 'Disclosure--item')
 * @param content What to set the innerHtml of the element to
 *
 * @returns The newly created element with the class and innerHtml properties set
 */
const createElementWithContents = (tagName, className, content) => {
  const el = document.createElement(tagName);

  if (className) {
    el.className = className;
  }

  if (content) {
    el.innerHTML = content;
  }

  return el;
}
